const { FLUZ_UNIFIED_WHITELIST = '', FLUZ_POWER_URL, FLUZ_UNIFIED_URL } = process.env;

type whitelistType = {
  redirectFrom: 'POWER' | 'MOBILE' | 'UNIFIED' | undefined;
  referrer?: string;
};

export function whitelistRedirectTo({ redirectFrom, referrer = '' }: whitelistType) {
  if (redirectFrom === 'POWER') {
    return `${FLUZ_POWER_URL}/legacy-login`;
  } else if (redirectFrom === 'UNIFIED') {
    const whitelist = FLUZ_UNIFIED_WHITELIST?.split(',');
    const regTest = whitelist
      .map((val) => {
        if (val.startsWith('/') && val.endsWith('/')) {
          return new RegExp(val.substring(1, val.length - 1));
        }

        return null;
      })
      .filter(Boolean);

    if (!referrer) {
      return `${FLUZ_UNIFIED_URL}/login`;
    }
    const parsedUrl = new URL(referrer);

    let passedRegex = false;
    if (regTest?.length > 0) {
      passedRegex = regTest.some((reg: RegExp) => {
        return reg.test(parsedUrl.origin);
      });
    }

    if (passedRegex || whitelist.includes(parsedUrl.origin)) {
      const search = new URLSearchParams([]);
      if (referrer.indexOf('redirectTo') !== -1) {
        search.append('redirectTo', referrer.split('redirectTo=')[1]);
        return `${parsedUrl.origin}/login?${search.toString()}`;
      }

      return `${parsedUrl.origin}/login`;
    } else {
      return `${FLUZ_UNIFIED_URL}/login`;
    }
  } else {
    return 'fluz://?loginWithPassword=true';
  }
}
